import React, { useEffect } from "react";
import $ from "jquery";
import { Link, useLocation } from "react-router-dom";
import cn from "classnames";

const HeaderOne = () => {
  useEffect(() => {
    $(window).on("scroll", function () {
      const scroll = $(window).scrollTop();
      if (scroll < 245) {
        $("#sticky-header").removeClass("sticky-menu");
        $(".scroll-to-target").removeClass("open");
      } else {
        $("#sticky-header").addClass("sticky-menu");
        $(".scroll-to-target").addClass("open");
      }
    });

    $(function () {
      $(".header-btn").on("click", function () {
        $(".header-contact-wrap, .body-contact-overlay").toggleClass("active");
        $("body").toggleClass("fix");
        return false;
      });
      $(".body-contact-overlay").on("click", function () {
        $(".header-contact-wrap, .body-contact-overlay").removeClass("active");
        $("body").removeClass("fix");
        return false;
      });

      $(".mobile-nav-toggler").on("click", function () {
        $("body").addClass("mobile-menu-visible");
      });

      $(".menu-backdrop, .mobile-menu .close-btn").on("click", function () {
        $("body").removeClass("mobile-menu-visible");
      });
    });
  }, []);

  const { pathname } = useLocation();
  const isActiveClassName = (path) => (path === pathname ? "active" : "");
  const closeMobileMenu = () => {
    document.body.classList.remove("mobile-menu-visible");
  };

  return (
    <header>
      <div id="sticky-header" className="menu-area transparent-header">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="mobile-nav-toggler">
                <i className="fas fa-bars"></i>
              </div>

              <div className="menu-wrap">
                <nav className="menu-nav">
                  <div className="logo">
                    <Link to="/">
                      <img src="/img/logo/logo.png" alt="Logo" />
                    </Link>
                  </div>

                  <div className="navbar-wrap main-menu d-none d-lg-flex">
                    <ul className="navigation">
                      <li className={cn(isActiveClassName("/"))}>
                        <Link to="/">Home</Link>
                      </li>
                      <li className={cn(isActiveClassName("/about-us"))}>
                        <Link to="/about-us">Over ons</Link>
                      </li>
                    </ul>
                  </div>

                  <div className="header-action">
                    <ul className="list-wrap">
                      <li className="header-btn">
                        <a href="#!" className="btn">
                          Contact <span></span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </nav>
              </div>

              <div className="mobile-menu">
                <nav className="menu-box">
                  <div className="close-btn">
                    <i className="fas fa-times"></i>
                  </div>
                  <div className="nav-logo">
                    <Link to="/">
                      <img src="/img/logo/logo.png" alt="Logo" />
                    </Link>
                  </div>
                  <ul className="navigation">
                    <li className={cn(isActiveClassName("/"))}>
                      <Link to="/" onClick={closeMobileMenu}>Home</Link>
                    </li>
                    <li className={cn(isActiveClassName("/about-us"))}>
                      <Link to="/about-us" onClick={closeMobileMenu}>Over ons</Link>
                    </li>
                    <li className={cn(isActiveClassName("/contact"))}>
                      <Link to="/contact" onClick={closeMobileMenu}>Contact</Link>
                    </li>
                  </ul>
                </nav>
              </div>

              <div className="menu-backdrop"></div>
            </div>
          </div>
        </div>

        {/* Contact overlay */}
        <div className="header-contact-wrap">
          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <div className="left-side-content">
                  <h3 className="title">Contact</h3>
                  <div className="row">
                    <div className="col-xl-4 col-lg-5 col-md-6">
                      <div className="contact-info-list">
                        <ul className="list-wrap">
                          <li>
                            <div className="icon">
                              <i className="fas fa-envelope"></i>
                            </div>
                            <div className="content">
                              <a href="mailto:info@dianakledingreparatie.nl">
                                info@dianakledingreparatie.nl
                              </a>
                            </div>
                          </li>
                          <li>
                            <div className="icon">
                              <i className="fas fa-map-marker-alt"></i>
                            </div>
                            <div className="content">
                              <span>Abtsweg 41A - 43A, 3042 GA Rotterdam</span>
                            </div>
                          </li>
                          <li>
                            <div className="icon">
                              <i className="fas fa-clock"></i>
                            </div>
                            <div className="content">
                              <span>06-14507471</span>
                            </div>
                          </li>
                        </ul>
                        <div className="lats-chat">
                          <Link to="/contact">Hulp nodig of vragen?</Link>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-8 col-lg-7 col-md-6">
                      <div className="our-best-project">
                        <div className="content">
                          <h4 className="title">
                            Meer weten over <span>Vernu Stoffering?</span>
                          </h4>
                          <Link to="/about-us" className="btn">
                            Details <span></span>
                          </Link>
                        </div>
                        <div className="thumb">
                          <img
                            src="/img/images/our_project_img.png"
                            alt="Project"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="customer-support-wrap">
                  <h4 className="title">Klantenservice</h4>
                  <div className="customer-support-content">
                    <div className="content-top">
                      <img
                        src="/img/images/support_img.png"
                        alt="Support"
                      />
                      <h4 className="title">
                        Hulp nodig bij het kiezen van een plan?
                      </h4>
                    </div>
                    <p>
                      We bieden oplossingen voor elk formaat bedrijf.{" "}
                      <Link to="/contact">Neem contact op</Link> met onze
                      experts.
                    </p>
                    {/* ✅ Links verwijderd */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="body-contact-overlay"></div>
      </div>
    </header>
  );
};

export default HeaderOne;
